import { Box } from "@mui/material";
import Radio, { RadioProps } from "@mui/material/Radio";
import { makeStyles, withStyles, styled } from "@mui/styles";
import { Theme } from "@mui/material";
import clsx from "clsx";
import {
  SURVEY_COLORS,
  SURVEY_TYPOGRAPHY,
  SURVEY_SPACING,
  TEXTAREA_STYLES,
} from "./theme-constants";

// TODO : Review this post upgrading to tailwind to refactor these to use tailwind classes instead of custom styles
// TextArea Component
export const TextAreaComponent = styled("textarea")({
  padding: TEXTAREA_STYLES.padding,
  width: "100%",
  fontSize: TEXTAREA_STYLES.fontSize,
  fontFamily: TEXTAREA_STYLES.fontFamily,
  color: SURVEY_COLORS.TEXT_PRIMARY,
  boxSizing: "border-box",
  lineHeight: SURVEY_TYPOGRAPHY.LINE_HEIGHT_NORMAL,
  fontWeight: SURVEY_TYPOGRAPHY.FONT_WEIGHT_NORMAL,
  resize: "none" as const,
  overflow: "auto" as const,
  border: `1px solid ${SURVEY_COLORS.BORDER_DEFAULT}`,
  borderRadius: SURVEY_SPACING.BORDER_RADIUS,
});

export const ErrorMessage = styled("div")(() => ({
  color: SURVEY_COLORS.ERROR,
  fontSize: SURVEY_TYPOGRAPHY.FONT_SIZE_ERROR,
  marginTop: SURVEY_SPACING.ERROR_MARGIN_TOP,
  marginBottom: SURVEY_SPACING.ERROR_MARGIN_BOTTOM,
})) as React.ComponentType<React.HTMLAttributes<HTMLDivElement>>;

// Note: Add role="alert" when using ErrorMessage for accessibility

// Radio Field Styles
const useRadioStyles = makeStyles((theme: Theme) => ({
  root: {
    marginLeft: "1px",
    "&:hover": {
      backgroundColor: "transparent",
    },
  },
  icon: {
    borderRadius: "50%",
    width: 14,
    height: 14,
    border: `1px solid ${theme.palette.grey["A100"]}`,
    backgroundColor: SURVEY_COLORS.WHITE,
  },
  checkedIcon: {
    backgroundColor: theme.palette.primary.main,
  },
  attendRadio: {
    border: `2px solid ${SURVEY_COLORS.BLACK} !important`,
  },
}));

// Styled Radio Component
export const StyledRadio = (props: RadioProps): React.ReactElement => {
  const classes = useRadioStyles();

  return (
    <Radio
      focusVisibleClassName={classes.attendRadio}
      className={classes.root}
      tabIndex={0}
      color="default"
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
      {...props}
    />
  );
};

// Radio Field Container
export const RadioField = withStyles((theme: Theme) => ({
  root: {
    marginTop: "27px",
    minWidth: 0,
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      minWidth: "500px",
    },
    " & fieldset": {
      fontFamily: "Arial",
      fontSize: "14px",
      color: theme.palette.grey["800"],
      letterSpacing: 0,
      fontWeight: 400,
      marginBottom: "13px",
    },
    " & div": {
      "& label": {
        paddingLeft: "5px",
        margin: 0,
      },
    },
  },
}))(Box);
